/**
 * Stock Movements List Page
 * 
 * Filter panel UI, date input bridging for Flowbite datepicker.
 * Filtering/sorting/pagination is handled declaratively by HTMX.
 */

/**
 * Initialize the movements list page.
 *
 * ``options.hasActiveFilters`` drives whether the filter panel starts
 * open — used to preserve the user's filter view across hx-boost
 * navigation when the URL carries any active filter.
 */
export function initMovementsList(options = {}) {
  const { hasActiveFilters = false } = options;
  initFilterPanelUI(hasActiveFilters);
  initDatepickerBridge();
  bindAfterSettleOnce();
}

function initFilterPanelUI(hasActiveFilters) {
  var panel = document.getElementById('filter-panel');
  var chevron = document.getElementById('filter-chevron');
  var toggleBtn = document.getElementById('toggle-filters-btn');
  var resetBtn = document.getElementById('reset-filters-btn');
  var clearSearchBtn = document.getElementById('clear-search-btn');
  var form = document.getElementById('movementFilterForm');
  var searchInput = document.getElementById('search-input');

  if (panel && hasActiveFilters) {
    panel.classList.remove('hidden');
    if (chevron) chevron.classList.add('rotate-180');
  }

  // Per-node idempotency via plain property — safe across hx-boost
  // history snapshots (dataset.* would be serialized).
  if (toggleBtn && panel && !toggleBtn._mvFilterBound) {
    toggleBtn._mvFilterBound = true;
    toggleBtn.addEventListener('click', function () {
      panel.classList.toggle('hidden');
      if (chevron) chevron.classList.toggle('rotate-180');
    });
  }

  if (resetBtn && form && !resetBtn._mvResetBound) {
    resetBtn._mvResetBound = true;
    resetBtn.addEventListener('click', function () {
      form.querySelectorAll('select').forEach(function (sel) {
        sel.value = '';
        var wrapper = sel.closest('.custom-select-wrapper');
        if (wrapper) {
          var textEl = wrapper.querySelector('.custom-select-text');
          if (textEl && sel.options[0]) {
            textEl.textContent = sel.options[0].text;
          }
        }
      });
      if (searchInput) searchInput.value = '';
      if (clearSearchBtn) clearSearchBtn.classList.add('hidden');

      form.querySelectorAll('input[name="date_from"], input[name="date_to"]').forEach(function (input) {
        input.value = '';
      });

      var consumableInput = form.querySelector('input[name="consumable"]');
      if (consumableInput) consumableInput.value = '';

      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (clearSearchBtn && searchInput && form && !clearSearchBtn._mvClearBound) {
    clearSearchBtn._mvClearBound = true;
    clearSearchBtn.addEventListener('click', function () {
      searchInput.value = '';
      clearSearchBtn.classList.add('hidden');
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (searchInput && clearSearchBtn && !searchInput._mvInputBound) {
    searchInput._mvInputBound = true;
    searchInput.addEventListener('input', function () {
      clearSearchBtn.classList.toggle('hidden', !searchInput.value.trim());
    });
  }
}

/**
 * Bridge Flowbite datepicker's changeDate event to a native change event
 * so HTMX's hx-trigger can pick it up.
 */
function initDatepickerBridge() {
  var form = document.getElementById('movementFilterForm');
  if (!form) return;

  form.querySelectorAll('input[datepicker]').forEach(function (input) {
    if (input._mvDpBound) return;
    input._mvDpBound = true;
    input.addEventListener('changeDate', function () {
      this.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

let afterSettleBound = false;

function bindAfterSettleOnce() {
  if (afterSettleBound) return;
  afterSettleBound = true;
  document.addEventListener('htmx:afterSettle', function (e) {
    var target = e.detail && e.detail.target;
    if (!target || target.id !== 'list-results') return;
    if (typeof window.reinitFlowbiteWidgets === 'function') {
      window.reinitFlowbiteWidgets(target);
    }
  });
}

/**
 * Auto-init entry point (wired via ``data-auto-init="movementsList"``).
 */
export function autoInitMovementsList() {
  const root = document.querySelector('[data-auto-init="movementsList"]');
  if (!root) return;
  initMovementsList({
    hasActiveFilters: root.dataset.hasActiveFilters === '1',
  });
}

window.initMovementsList = initMovementsList;
